import { render } from "./TextModule.vue?vue&type=template&id=74eb7639"
import script from "./TextModule.vue?vue&type=script&lang=js"
export * from "./TextModule.vue?vue&type=script&lang=js"

import "./TextModule.vue?vue&type=style&index=0&id=74eb7639&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__